




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import CommandPO from "@/store/entities/devices/commandlistpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  components: { TreeSelect },
})
export default class CopyCommand extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  commandpo: CommandPO = new CommandPO();
  created() {
    this.areaTree();
    this.getItemDetail();
    this.getCollectorList();
    this.getMeterList();
  }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "commandlist/create",
          data: this.commandpo,
        });
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.commandpo = Util.extend(
        true,
        {},
        this.$store.state.commandlist.commandListItems
      );
    }
  }
  async getCollectorList() {
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.collectorList.push({ label: ele.no, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getMeterList() {
    await this.$store
      .dispatch("meter/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.meterList.push({ label: ele.meterNo, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 15;
      });
      info.forEach((ele) => {
        this.$data.commandtype.push({ label: ele.name, value: ele.id });
      });
    }
  }
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  itemRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
    meterId: [
      {
        trigger: "blur",
      },
    ],
    roomNo: [
      {
        trigger: "blur",
      },
    ],
    collectorId: [
      {
        trigger: "blur",
      },
    ],
    commandType: [
      {
        trigger: "blur",
        required: true,
        type: "number",
        message:
          this.L("Command") + this.L("Category") + this.L("CanNotBeEmpty"),
      },
    ],
    commandStr: [
      {
        trigger: "blur",
        required: true,
        message: this.L("Command") + this.L("CanNotBeEmpty"),
      },
    ],
  };
  data() {
    return {
      arealist: [],
      commandtype: [],
      collectorList: [],
      meterList: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
